import { UiModal, UiToast } from 'components';
import roomLib from '../room';
import giftLib from 'widgets/functions/gift/gift';
import animate from 'widgets/functions/animation/animate';
import { user } from 'lib';

const handle = (socket) => {
  // 加入／移除 灰名单 弹框警告
  socket.on('star.alerting', (msg) => {
    UiModal.alert('提示', msg.data_d.remark);
  });

  socket.on('room.close', (msg) => {
    const prevConfig = {
        1: '官方客服：',
        5: '么么代理：',
      },
      prev = prevConfig[msg.data_d.priv + ''] || '';

    UiToast.warn(prev + msg.data_d.reason || '房间已被关闭', () => {
      if (roomLib.isRoomOwner()) {
        user.logout();
      } else {
        location.href = '/';
      }
    });
  });

  socket.on('room.freeze', (msg) => {
    UiModal.alert('提示', msg.data_d.reason || '房间已被关闭', () => {
      if (roomLib.isRoomOwner()) {
        UiToast.warn('您的帐号已经被冻结', () => {
          user.logout();
        });
      } else {
        location.href = '/';
      }
    });
  });

  socket.on('sys.freeze', (msg) => {
    UiToast.warn('您的帐号已经被冻结', () => {
      user.logout();
    });
  });
  socket.on('guard.join', (msg, { room }) => {
    const data = {
      isFirstPlay: true,
      from: msg.data,
      to: room.starInfo.toJSON(),
      gift: $.extend({ count: 1 }, giftLib.getGift(msg.data.gift_id)),
      text:
        msg.data.nickname.substring(0, 10) +
        ' 开通 ' +
        ['星之守护', '王之守护', '神之守护'][msg.data.level - 1],
    };
    animate.push(data);
  });
};

export default handle;
